import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '@/store'

const selectViewState = (state: RootState) => state.structuredDataState

export const selectStructuredDataState = createSelector(
  selectViewState,
  (state) => state.structuredDataState,
)
